import produce from 'immer';
import CommonConstants from 'src/common/helpers/CommonConstants';
import { loginActions } from '../../../views/public/login/actions';
import {
  getUserInfo,
  getUserRefreshToken,
  getUserToken,
} from '../../helpers/StorageUtils';
import { userActions } from './actions';

const deviceAlarmSettingsLocalSaved = localStorage.getItem(
  'DEVICE_ALARM_SETTINGS'
);
const deviceAlarmSettingsLocalSavedJSONParsed = deviceAlarmSettingsLocalSaved
  ? JSON.parse(deviceAlarmSettingsLocalSaved)
  : null;

const initialState = {
  actionType: '',
  idToken: getUserToken(),
  refreshToken: getUserRefreshToken(),
  userInfo: getUserInfo(),
  isLoadingProfile: true,
  isLoadingDeviceAlarmSettings: false,
  deviceAlarmSettings: deviceAlarmSettingsLocalSavedJSONParsed || {
    onOffSetting: CommonConstants.ALARM_FLUSHINGS.OFF,
    isAlarmSound: false,
    alarmFlagsSnoozed: {},
  },
  isSnoozeExpired: true,
};

const broadcastChannel = new BroadcastChannel('AUTH_CHANNEL');

const User = (state = initialState, action) => {
  const { type: actionType, payload } = action;
  switch (actionType) {
    case userActions.UPDATE_IS_SNOOZE_EXPIRED:
      return produce(state, (draft) => {
        draft.isSnoozeExpired = payload.isSnoozeExpired;
      });
    case loginActions.LOGIN_SUCCESS:
      broadcastChannel.postMessage({ actionType });
      return produce(state, (draft) => {
        draft.idToken = payload.idToken;
        draft.refreshToken = payload.refreshToken;
      });
    case loginActions.LOGOUT_SUCCESS:
    case loginActions.TOKEN_EXPIRED_SUCCESS:
      broadcastChannel.postMessage({ actionType });
      return produce(state, (draft) => {
        draft.idToken = null;
        draft.refreshToken = null;
        draft.userInfo = null;
      });

    case userActions.FETCH_DEVICE_ALARM_SETTING:
    case userActions.UPDATE_DEVICE_ALARM_SETTING:
      return produce(state, (draft) => {
        draft.isLoadingDeviceAlarmSettings = true;
      });

    case userActions.FETCH_DEVICE_ALARM_SETTING_SUCCESS:
    case userActions.UPDATE_DEVICE_ALARM_SETTING_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoadingDeviceAlarmSettings = false;
        draft.deviceAlarmSettings = payload;
        draft.actionType = actionType;
      });
    case userActions.FETCH_DEVICE_ALARM_SETTING_ERROR:
    case userActions.UPDATE_DEVICE_ALARM_SETTING_ERROR:
      return produce(state, (draft) => {
        draft.isLoadingDeviceAlarmSettings = false;
      });
    case userActions.UPDATE_DEVICE_ALARM_SETTING_RESET_STATE:
      return produce(state, (draft) => {
        draft.actionType = '';
      });

    case userActions.GET_USER_PROFILE:
      return produce(state, (draft) => {
        draft.isLoadingProfile = true;
        draft.actionType = actionType;
      });
    case userActions.GET_USER_PROFILE_SUCCESS:
      return produce(state, (draft) => {
        draft.isLoadingProfile = true;
        draft.userInfo = payload;
      });
    case userActions.GET_USER_PROFILE_ERROR:
      return produce(state, (draft) => {
        draft.isLoadingProfile = false;
        draft.actionType = actionType;
      });

    default:
      return state;
  }
};

export default User;
